import React from 'react'

export const IconRefund = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25C16.0041 19.25 19.25 16.0041 19.25 12C19.25 7.99594 16.0041 4.75 12 4.75ZM3.25 12C3.25 7.16751 7.16751 3.25 12 3.25C16.8325 3.25 20.75 7.16751 20.75 12C20.75 16.8325 16.8325 20.75 12 20.75C7.16751 20.75 3.25 16.8325 3.25 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5343 7.83686C11.6578 7.71715 11.8253 7.6499 12 7.6499C12.1747 7.6499 12.3422 7.71715 12.4657 7.83686L16.3071 11.5603C16.5643 11.8095 16.5643 12.2137 16.3071 12.463C16.0499 12.7122 15.633 12.7122 15.3758 12.463L12.75 9.91784V15.6499C12.75 16.0641 12.4142 16.3999 12 16.3999C11.5858 16.3999 11.25 16.0641 11.25 15.6499V9.91784L8.62419 12.4629C8.36702 12.7122 7.95006 12.7122 7.69288 12.4629C7.43571 12.2137 7.43571 11.8095 7.69288 11.5603L11.5343 7.83686Z"
      fill="currentColor"
    />
  </svg>
)
